export const VIEWS = {
  WebsiteImage: 'WebsiteImage',
  StockImage: 'StockImage',
  SocialMedia: 'SocialMedia',
  LandingPage: 'LandingPage',
  AIGCImage: 'AI-generated',
  InvestImage: 'InvestImage',
};
